export const getFriendlyName = (name: string): string => {
  return name.split('/').reverse()[0];
};
